/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  RoleDefinitionResolver,
  RoleDefinitionResolverInterface,
} from "../RoleDefinitionResolver";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ENS",
        name: "_ens",
        type: "address",
      },
      {
        internalType: "contract DomainNotifier",
        name: "_notifier",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "contentType",
        type: "uint256",
      },
    ],
    name: "ABIChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "AddrChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "newAddress",
        type: "bytes",
      },
    ],
    name: "AddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isAuthorised",
        type: "bool",
      },
    ],
    name: "AuthorisationChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "ContenthashChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "name",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "record",
        type: "bytes",
      },
    ],
    name: "DNSRecordChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "name",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
    ],
    name: "DNSRecordDeleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "DNSZoneCleared",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "lastzonehash",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "zonehash",
        type: "bytes",
      },
    ],
    name: "DNSZonehashChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "address",
        name: "implementer",
        type: "address",
      },
    ],
    name: "InterfaceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "newType",
        type: "uint8",
      },
    ],
    name: "IssuerTypeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "dids",
            type: "address[]",
          },
          {
            internalType: "bytes32",
            name: "role",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct IssuersResolver.Issuers",
        name: "newIssuers",
        type: "tuple",
      },
    ],
    name: "IssuersChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NameChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bytes32[]",
            name: "roles",
            type: "bytes32[]",
          },
          {
            internalType: "bool",
            name: "mustHaveAll",
            type: "bool",
          },
        ],
        indexed: false,
        internalType:
          "struct EnrolmentPrerequisiteRolesResolver.PrerequisiteRoles",
        name: "newPrerequisiteRoles",
        type: "tuple",
      },
    ],
    name: "PrerequisiteRolesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    name: "PubkeyChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "string",
        name: "indexedKey",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "TextChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVersion",
        type: "uint256",
      },
    ],
    name: "VersionNumberChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "contentTypes",
        type: "uint256",
      },
    ],
    name: "ABI",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorisations",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "clearDNSZone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "contenthash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
    ],
    name: "dnsRecord",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "hasDNSRecords",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "interfaceImplementer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "issuerType",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "issuerTypes",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "issuers",
    outputs: [
      {
        internalType: "address[]",
        name: "dids",
        type: "address[]",
      },
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "prerequisiteRoles",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "roles",
        type: "bytes32[]",
      },
      {
        internalType: "bool",
        name: "mustHaveAll",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "pubkey",
    outputs: [
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "contentType",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "setABI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "a",
        type: "bytes",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isAuthorised",
        type: "bool",
      },
    ],
    name: "setAuthorisation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "setContenthash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "setDNSRecords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "implementer",
        type: "address",
      },
    ],
    name: "setInterface",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address[]",
        name: "dids",
        type: "address[]",
      },
    ],
    name: "setIssuerDids",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "setIssuerRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "newIssuerType",
        type: "uint8",
      },
    ],
    name: "setIssuerType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "roles",
        type: "bytes32[]",
      },
      {
        internalType: "bool",
        name: "mustHaveAll",
        type: "bool",
      },
    ],
    name: "setPrerequisiteRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    name: "setPubkey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
      {
        internalType: "string",
        name: "value",
        type: "string",
      },
    ],
    name: "setText",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "newVersionNumber",
        type: "uint256",
      },
    ],
    name: "setVersionNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "setZonehash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "text",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "versionNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "versionNumbers",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "zonehash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "domainUpdated",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

type RoleDefinitionResolverConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RoleDefinitionResolverConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RoleDefinitionResolver__factory extends ContractFactory {
  constructor(...args: RoleDefinitionResolverConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "RoleDefinitionResolver";
  }

  deploy(
    _ens: string,
    _notifier: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<RoleDefinitionResolver> {
    return super.deploy(
      _ens,
      _notifier,
      overrides || {}
    ) as Promise<RoleDefinitionResolver>;
  }
  getDeployTransaction(
    _ens: string,
    _notifier: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_ens, _notifier, overrides || {});
  }
  attach(address: string): RoleDefinitionResolver {
    return super.attach(address) as RoleDefinitionResolver;
  }
  connect(signer: Signer): RoleDefinitionResolver__factory {
    return super.connect(signer) as RoleDefinitionResolver__factory;
  }
  static readonly contractName: "RoleDefinitionResolver";
  public readonly contractName: "RoleDefinitionResolver";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RoleDefinitionResolverInterface {
    return new utils.Interface(_abi) as RoleDefinitionResolverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RoleDefinitionResolver {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as RoleDefinitionResolver;
  }
}
